import { Link } from "react-router-dom";
import { getCategoryName, type Comic } from "@/mocks/comics";

interface Props {
  comic: Comic;
}

export default function ComicCard({ comic }: Props) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block overflow-hidden rounded-lg bg-background-50"
      title={`${comic.title} 高清原图漫画`}
      aria-label={`查看漫画 ${comic.title}`}
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden rounded-lg">
        <img
          src={comic.cover}
          alt={`${comic.title} 漫画封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/50 to-transparent"></div>
        <span className="absolute right-2 top-2 whitespace-nowrap rounded-full bg-black/50 px-2.5 py-1 text-xs text-white backdrop-blur-sm">
          {comic.status}
        </span>
        <div className="absolute bottom-2 left-2 flex items-center gap-1 text-xs text-white">
          <i className="ri-star-fill text-accent-400"></i>
          <span>{comic.rating.toFixed(1)}</span>
        </div>
        <div className="absolute bottom-2 right-2 flex items-center gap-1 text-xs text-white">
          <i className="ri-eye-line"></i>
          <span className="whitespace-nowrap">{comic.views}</span>
        </div>
      </div>
      <div className="pt-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-500 md:text-base">
          {comic.title}
        </h3>
        <p className="mt-1 flex items-center gap-2 text-xs text-foreground-600 md:text-sm">
          <span className="whitespace-nowrap text-primary-600">{getCategoryName(comic.category)}</span>
          <span className="truncate whitespace-nowrap">{comic.author}</span>
        </p>
        <p className="mt-1 text-xs text-foreground-500 md:text-sm">
          更新:{comic.lastUpdate}
        </p>
      </div>
    </Link>
  );
}